import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import ContactForm from "../../components/contact-form/contact-form";

const CONTACT = () => {
    return (
        <div>
            <Navbar />
            <ContactForm/>
            <Footer />
        </div>
    )
}

export default CONTACT;